import { ProjectsRoutes } from '../helpers/routes_by_project';
import { routes as Routes } from '../types/global.types';

const projectKey = '95942005';

export const routes: Routes = ProjectsRoutes[projectKey];
